import { LOCK_SENSITIVE_DATA, UNLOCK_SENSITIVE_DATA } from 'actions/types';

const sensitiveData = (state = {}, action) => {
  const { dataType, component, customerId } = action;

  switch (action.type) {
    case UNLOCK_SENSITIVE_DATA:
      return Object.assign({}, state, {
        [customerId]: {
          ...state[customerId],
          [component]: {
            ...(state[customerId] && state[customerId][component]),
            [dataType]: true,
          },
        },
      });
    case LOCK_SENSITIVE_DATA:
      return Object.assign({}, state, {
        [customerId]: {
          ...state[customerId],
          [component]: {
            ...(state[customerId] && state[customerId][component]),
            [dataType]: false,
          },
        },
      });
    default:
      return state;
  }
};

export default sensitiveData;
